import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router/router.js'
import 'lib-flexible'
Vue.prototype.baseUrl="//shimen-xhncloud.voc.com.cn/api";
Vue.prototype.$http = axios
Vue.config.productionTip = false
import Vant from 'vant';
import 'vant/lib/index.css';
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.use(Vant);
Vue.prototype.osUrl =function(){
  var u = navigator.userAgent;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if(isIOS){
	window.location.href='https://fir.im/xinsangzhiios';
  }else{
	window.location.href="https://fir.im/xinsangzhiAnd";  
  }
}
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
